import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FotaBatchPageComponent } from './fota-batch-page.component';

const routes: Routes = [
  {
    path: 'fota-batch',
    data: { name: 'fota-batch', isTab: false },
    component: FotaBatchPageComponent,
  },
  {
    path: 'fota-batch/:uid',
    component: FotaBatchPageComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FotaBatchPageRoutingModule {}
